<template>
  <b-card id="page-membership-form" no-body class="mb-0">
    <b-card-header>
      <b-card-title>
        <h2>
          {{ $t(getTitle()) }}
          {{ $t("pages.subscriptions.detailSubscription") }}
        </h2>
      </b-card-title>
      <b-button variant="primary" @click="backButton">
        <feather-icon icon="ArrowLeftIcon" />
        {{ $t("back") }}
      </b-button>
    </b-card-header>
    <b-card-body>
      <validation-observer ref="subscriptionform">
        <b-form>
          <b-row>
            <b-col cols="12" sm="6" md="6" lg="6" xl="6">
              <b-form-group :label="$t(label('company'))" label-for="company">
                <validation-provider
                  #default="{ errors }"
                  :name="$t(label('company'))"
                  rules="required"
                >
                  <b-form-input
                    id="company"
                    v-model="subscription.nameCompany"
                    :disabled="!isSaveMode"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t(label('company'))"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="12" sm="6" md="6" lg="6" xl="6">
              <validation-provider
                #default="{ errors }"
                :name="$t(label('subscriptionType'))"
                rules="required"
              >
                <b-form-group
                  :label="$t(label('subscriptionType'))"
                  label-for="subscriptionType"
                  :state="errors.length > 0 ? false : null"
                >
                  <v-select
                    v-model="subscription.guidSubscription"
                    input-id="subscriptionType"
                    :options="listSubscriptions"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    :placeholder="$t(label('subscriptionType'))"
                    :disabled="!isSaveMode"
                    :taggable="false"
                    :reduce="(option) => option.guid"
                    @search="searchCompaniesAll"
                    :filterable="false"
                    @open="onOpenSubscription"
                  >
                    <template #list-footer>
                      <li
                        v-show="hasNextPageSubscription"
                        ref="loadSubscription"
                        class="loader"
                      >
                        Cargando más opciones...
                      </li>
                    </template>
                  </v-select>
                  <b-form-invalid-feedback
                    :state="errors.length > 0 ? false : null"
                  >
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="12" sm="6" md="6" lg="6" xl="6">
              <b-form-group
                :label="$t(label('startDate'))"
                label-for="startDate"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t(label('startDate'))"
                  rules="required"
                >
                  <b-form-datepicker
                    id="startDate"
                    ref="startDate"
                    v-model="subscription.startDate"
                    :placeholder="$t(label('startDate'))"
                    :state="errors.length > 0 ? false : null"
                    :disabled="!isSaveMode"
                    class="mr-2"
                    reset-button
                    dropright
                    :min="new Date()"
                  >
                  </b-form-datepicker>

                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="12" sm="6" md="6" lg="6" xl="6">
              <b-form-group :label="$t(label('endDate'))" label-for="endDate">
                <validation-provider
                  #default="{ errors }"
                  :name="$t(label('endDate'))"
                  rules="required"
                >
                  <b-form-datepicker
                    id="endDate"
                    ref="endDate"
                    v-model="subscription.endDate"
                    :placeholder="$t(label('endDate'))"
                    :state="errors.length > 0 ? false : null"
                    :disabled="!isSaveMode"
                    class="mr-2"
                    reset-button
                    dropright
                    :min="new Date()"
                  >
                  </b-form-datepicker>

                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="12" md="2">
              <validation-provider
                #default="{ errors }"
                :name="$t(label('status'))"
                rules="required"
              >
                <b-form-group
                  :label="$t(label('status'))"
                  label-for="status"
                  :state="errors.length > 0 ? false : null"
                >
                  <b-form-checkbox
                    id="status"
                    v-model="subscription.active"
                    switch
                    inline
                    @input.native="changeSatus($event)"
                    :disabled="!isSaveMode"
                  >
                    {{ isStatus(subscription.active) }}
                  </b-form-checkbox>
                  <b-form-invalid-feedback
                    :state="errors.length > 0 ? false : null"
                  >
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col
              class="d-flex justify-content-end align-items-center"
              cols="12"
            >
              <b-button
                v-if="option == 3"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="primary"
                class="mr-1"
                @click.prevent="onSubmit"
              >
                {{ $t("save") }}
              </b-button>
              <!-- <b-button
                v-if="option == 2"
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="reset"
                variant="outline-secondary"
                @click="onCancel"
              >
                {{ $t("cancel") }}
              </b-button> -->
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card-body>
  </b-card>
</template>

<script>
import _ from "lodash";

import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import {
  BInputGroup,
  BCard,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BFormGroup,
  BFormCheckbox,
  BForm,
  BFormTextarea,
  BToast,
  BMedia,
  BFormInvalidFeedback,
  BFormDatepicker,
  BFormTimepicker,
} from "bootstrap-vue";
import router from "@/router";
import Ripple from "vue-ripple-directive";
import { showLoading, stopLoading, getParams } from "@core/utils/utils";
import { required, integer } from "@validations";
import vSelect from "vue-select";
import { postFile } from "@core/api/request/catalogs";
import { VueTelInput } from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";
import { allSubcriptions } from "@/@core/api/request/subcription";
import {
  allMembershipsOfcompany,
  editMembership,
} from "@/@core/api/request/membership";
import flatPickr from "vue-flatpickr-component";

import moment from "moment";

const subscription = {
  idSubscriptionCompany: null,
  idSubscription: null,
  guidSubscription: null,
  nameSubscription: null,
  idCompany: null,
  guidCompany: null,
  nameCompany: null,
  startDate: null,
  endDate: null,
  active: null,
  subscription: null,
};

export default {
  components: {
    BInputGroup,
    ValidationProvider,
    ValidationObserver,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    vSelect,
    BFormTextarea,
    BToast,
    BFormInvalidFeedback,
    BMedia,
    BFormDatepicker,
    BFormTimepicker,
    VueTelInput,
    flatPickr,
  },

  directives: {
    Ripple,
  },
  data() {
    return {
      isSaveMode: true,
      companyGuid: null,
      required,
      integer,
      subscription: Object.assign(subscription),
      option: "",
      listSubscriptions: [],
      loading: false,
      currentPageSubscriptions: 1,
      perPageSubscriptions: 20,
      totalPagesSubscription: null,
      observerCompanies: null,
      hasNextPageSubscription: true,
      loadingSubscription: false,
    };
  },
  created() {
    localize("es");
  },
  computed: {},
  mounted() {
    this.subscription = {
      idSubscriptionCompany: null,
      idSubscription: null,
      guidSubscription: null,
      nameSubscription: null,
      idCompany: null,
      guidCompany: null,
      nameCompany: null,
      startDate: null,
      endDate: null,
      active: null,
      subscription: null,
    };
    this.companyGuid = this.$store.state.appConfig.activeCompanyGuid;
    this.initialize();
    const observers = [
      { name: "companies", callback: this.infiniteScrollSubscription },
    ];

    observers.forEach((observer) => {
      this[
        `observer${
          observer.name.charAt(0).toUpperCase() + observer.name.slice(1)
        }`
      ] = new IntersectionObserver(observer.callback);
    });
  },
  watch: {
    "$store.state.appConfig.activeCompanyGuid"(guid) {
      this.companyGuid = guid;
    },
  },
  methods: {
    backButton() {
      this.onCancel();
      this.goBack();
    },

    deleteFile(field) {
      this.promotion[field] = null;
    },

    handleDragover(e) {
      e.stopPropagation();
      e.preventDefault();
      e.dataTransfer.dropEffect = "copy";
    },

    onFileChange(e, field) {
      if (e?.target?.files?.length > 0) {
        this.onTransFile(
          e?.target?.files,
          e.target.accept,
          e.target.multiple,
          field,
        );
      }
    },

    onTransFile(files, accept, multiple, field) {
      if (multiple) return;
      this.loadingPhoto = true;
      files.forEach((file) => {
        if (!file) return;
        const type = file.type.split("/").pop();
        const isPdf = type === "pdf";
        const isImage = ["jpeg", "jpg", "png"].includes(type);
        if (!isPdf && !isImage) return;
        showLoading();
        postFile(file)
          .then((resp) => {
            this.subscription[field] = resp.data;
          })
          .catch(console.error)
          .finally(() => {
            this.loadingPhoto = false;
            stopLoading();
          });
      });
    },

    resetData() {
      this.subscription = {
        idSubscriptionCompany: null,
        idSubscription: null,
        guidSubscription: null,
        nameSubscription: null,
        idCompany: null,
        guidCompany: null,
        nameCompany: null,
        startDate: null,
        endDate: null,
        active: null,
        subscription: null,
      };
      this.hasNextPageSubscription = true;
    },

    async loadData() {
      await Promise.all([this.getListSubscriptions()]);
    },
    label(field) {
      return `pages.subscriptions.form.label.${field}`;
    },
    getTitle() {
      if (this.option === 1) return "register";
      else if (this.option === 2) return "show";
      else if (this.option === 3) return "edit";
    },
    async initialize() {
      this.companyGuid = this.$route.params.guidCompany;
      this.option = this.$route.params.option;
      if (this.companyGuid === undefined) {
        router.push({ name: "AdminPaymentHistories" }).catch(() => {});
      }
      await this.loadData();
      switch (this.option) {
        case 1:
          this.onCancel();
          break;
        // option 2 to show, option 3 to edit
        case 2:
        case 3:
          if (this.$route.params.guidCompany === undefined) {
            router.push({ name: "AdminPaymentHistories" }).catch(() => {});
          }
          this.isSaveMode = this.option !== 2;
          await this.getSubscriptionById(this.$route.params.guidCompany);
          break;
      }
    },
    async getSubscriptionById(companyGuid) {
      if (this.loadingSubscription) return;

      this.loadingSubscription = true;
      await allMembershipsOfcompany(companyGuid)
        .then((resp) => {
          const data = _.get(resp, "data");
          if (data != null) {
            this.subscription = Object.assign({
              idSubscriptionCompany: data?.idSubscriptionCompany,
              idSubscription: data?.idSubscription,
              guidSubscription: data?.guidSubscription,
              nameSubscription: data?.nameSubscription,
              idCompany: data?.idCompany,
              guidCompany: data?.guidCompany,
              nameCompany: data?.nameCompany,
              startDate: data?.startDate,
              endDate: data?.endDate,
              active: data?.active == 1 ? true : false,
              subscription: data?.subscription,
            });
          }
        })
        .catch((error) => {
          console.log("error", error);
        })
        .finally(() => {
          this.loadingSubscription = false;
        });
    },
    async onOpenSubscription() {
      if (this.hasNextPageSubscription) {
        await this.$nextTick();
        this.observerCompanies.observe(this.$refs.hasNextPageSubscription);
      }
    },
    async searchCompaniesAll(value) {
      this.listSubscriptions = [];
      this.currentPageSubscriptions = 1;
      this.hasNextPageSubscription = true;
      this.getListSubscriptions();
    },
    onSubmit() {
      this.$refs.subscriptionform.validate().then((success) => {
        if (success) {
          // showLoading();
          const data = {
            idSubscriptionCompany: this.subscription?.idSubscriptionCompany,
            guidCompany: this.subscription?.guidCompany,
            guidSubscription: this.subscription?.guidSubscription,
          };

          editMembership(data)
            .then((resp) => {
              stopLoading();
              if (resp.data.err) {
                this.alertToast("danger", "Error", `${resp.data.message}`);
                return;
              }
              this.alertToast("success", "Éxito!", `Hola`);
              this.goBack();
            })
            .catch((error) => {
              stopLoading();
              this.alertToast("danger", "Error", error.message);
              stopLoading();
            });
        }
      });
    },
    onCancel() {
      this.subscription = Object.assign({
        idSubscriptionCompany: null,
        idSubscription: null,
        guidSubscription: null,
        nameSubscription: null,
        idCompany: null,
        guidCompany: null,
        nameCompany: null,
        startDate: null,
        endDate: null,
        active: null,
        subscription: null,
      });
    },
    alertToast(type = null, title = null, message = null) {
      this.$bvToast.toast(message, {
        title,
        variant: type,
        solid: true,
        icon: "CoffeeIcon",
      });
    },
    goBack() {
      this.$refs.subscriptionform.reset();
      router.back();
    },
    async infiniteScrollSubscription(values) {
      const value = values[0];

      if (value.isIntersecting) {
        this.currentPageSubscriptions++;
        await this.getListSubscriptions();
      }
    },
    chargeParamsByAdmin() {
      const arrParams = [];

      arrParams.push(`page,${this.currentPageSubscriptions}`);

      arrParams.push(`rows,${this.perPageSubscriptions}`);
      // if (
      //   this.companyGuid != null &&
      //   this.companyGuid.trim() !== "" &&
      //   this.companyGuid != "null"
      // )
      //   arrParams.push(`guidCompany,${this.companyGuid}`);

      return getParams(arrParams);
    },
    async getListSubscriptions() {
      this.loading = !this.loading;
      if (!this.hasNextPageSubscription) return;
      const param = this.chargeParamsByAdmin();
      await allSubcriptions(param)
        .then((resp) => {
          const data = _.get(resp, "data");
          this.listSubscriptions = [...this.listSubscriptions, ...data?.items];
          this.loading = !this.loading;
          this.currentPageSubscriptions = data?.currentPage;
          this.totalPagesSubscription = data?.totalPages || 0;
          this.hasNextPageSubscription =
            this.currentPageSubscriptions < this.totalPagesSubscription;
        })
        .catch((error) => {
          console.log("error", error);
          this.loading = !this.loading;
          this.hasNextPageSubscription = false;
          this.alertToast("danger", `Alerta codigo`, error.message);
        });
    },
    isStatus(value) {
      return value ? "Activa" : "Inactiva";
    },
  },
};
</script>

<style lang="scss">
.img-avatar {
  height: auto !important;
}
</style>
